import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-secondary-200/70">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-lg text-background-50"></i>
              </div>
              <span className="text-xl font-semibold font-heading text-foreground-950">
                韩漫画网
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              韩漫画网是国内领先的韩漫免费阅读平台，提供下拉式完整版韩漫免费阅读和无删减漫画免费阅读服务。韩漫大全每日更新，恋爱、奇幻、动作、剧情等各类韩漫应有尽有。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              漫画分类
            </h4>
            <div className="grid grid-cols-2 gap-2">
              {categories.filter((c) => c.slug !== 'all').map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              热门推荐
            </h4>
            <div className="space-y-2">
              <Link to="/comic/comic-01" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                公爵夫人的秘密
              </Link>
              <Link to="/comic/comic-02" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                剑之帝王
              </Link>
              <Link to="/comic/comic-04" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                魔王的养女
              </Link>
              <Link to="/comic/comic-13" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                九尾狐传
              </Link>
              <Link to="/comic/comic-06" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                社内相亲
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              关于我们
            </h4>
            <div className="space-y-2">
              <Link to="/about" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                品牌介绍
              </Link>
              <a href="mailto:contact@hanmanhua.com" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                联系我们
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 韩漫画网 - 下拉式完整版韩漫免费阅读 | 无删减漫画免费阅读 | 韩漫大全
          </p>
          <p className="text-xs text-foreground-400">
            本站所有漫画均来自互联网，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}